import axios from "axios";
import { message, Modal } from "antd";
import { getEnv } from "@/utils";
import { Cookie } from "@/utils/cookie";

const apiHost = {
  dev: "https://test.platform.us.9five.cn/api",
  // dev: "http://192.168.2.231:8010",
  test: "https://test.platform.us.9five.cn/api",
  uat: "https://test.platform.us.9five.cn/api",
  prod: "https://platform-us.9five.ai/api",
};

const url =
  process.env.NODE_ENV === "development" ? apiHost.dev : apiHost[getEnv()];

const http = axios.create({
  baseURL: url,
  timeout: 30 * 1000,
  // withCredentials: true,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
    Authorization: `Bearer ${Cookie.get("token")}`,
  },
});

// Add a request interceptor
http.interceptors.request.use(
  (config) => {
    return {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${Cookie.get("token")}`,
      },
    };
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Add a response interceptor
http.interceptors.response.use(
  (response) => {
    if (response.status === 401 || response.data.code === 401) {
      document.cookie = "token= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
      Modal.error({
        title: "登录状态失效",
        content: "登录状态失效，请重新登陆。",
        keyboard: false,
        onOk: () => {
          window.location.href = "/login";
        },
      });
      return;
    }

    if (response.data.code !== 200) {
      const msg = response.data.message;
      if (typeof msg === "string") {
        message.error(response.data.message || "服务异常，请稍后重试");
      }
      // return Promise.reject(response.data);
    }

    return response.data;
  },
  (error) => {
    console.log("error", error, error.response);
    if (
      error.response &&
      (error.response?.status === 401 ||
        error.response?.request?.status === 401)
    ) {
      document.cookie = "token= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
      window.location.href = "/login";
    } else {
      message.error("网络开小差了，请稍后重试");
    }
    return Promise.reject(error);
  },
);

export default http;
